import ConsultationV2 from "./ConsultationV2";

const DemoConsultation = () => {
  return <ConsultationV2 isSharedView />;
};

export default DemoConsultation;
